import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="day-checkbox"
export default class extends Controller {
  static targets = ["checkbox", "label"];

  connect() {
    this.updateLabel();
  }

  toggle(event) {
    event.preventDefault();
    const checkbox = this.checkboxTarget;
    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event("change"));
    this.updateLabel();
  }

  updateLabel() {
    const checkbox = this.checkboxTarget;
    const label = this.labelTarget;

    if (checkbox.checked) {
      label.classList.remove(
        "bg-gray-100",
        "text-gray-700",
        "border-gray-300",
        "dark:bg-gray-700",
        "dark:text-gray-300",
        "dark:border-gray-600"
      );
      label.classList.add("bg-blue-600", "text-white", "border-blue-600");
    } else {
      label.classList.remove("bg-blue-600", "text-white", "border-blue-600");
      label.classList.add(
        "bg-gray-100",
        "text-gray-700",
        "border-gray-300",
        "dark:bg-gray-700",
        "dark:text-gray-300",
        "dark:border-gray-600"
      );
    }
  }
}
